import { API_URL, ENVIRONMENT } from "@config/app";

export const isLocal = () => ENVIRONMENT === "local";

export const apiUrl = () => {
  if (window === undefined) {
    return API_URL;
  }

  return API_URL;
};
